import { ITableColumnMetadata } from '../../components/CustomTable/interfaces';

const tableColumnMetadata: ITableColumnMetadata[] = [
  {
    key: 'ruc',
    displayName: 'Ruc'
  },
  {
    key: 'name',
    displayName: 'Empresa'
  },
  {
    key: 'address',
    displayName: 'Dirección'
  },
  {
    key: 'units',
    displayName: 'Unidad',
    type: 'list'
  }
];

export default tableColumnMetadata;
